<div class="border-0 px-4 py-1 scroll-container" ref="PermissionManagement">
  <NavigationBackButton />
  <div class="card-header card-header-primary card-nav-tabs shadow rounded-lg mt-2">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <ul class="nav nav-tabs" data-tabs="tabs">
            <li class="rounded-lg me-2 nav-item">
              <a class="text-white text-decoration-none text-x fw-bold nav-link" href="#profile" data-toggle="tab">
                Assigning Permission Features
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  <div class="card rounded-lg border-0 shadow mt-2">
    <div class="card-body p-3 pt-2 bg-white rounded-lg">
      <label class="fw-bold text-xs mb-4 mt-4">Select feature</label>

      <div v-for="main_feature in permissions" :key="main_feature.id" class="mb-2">
        <div
          class="d-flex justify-content-between align-items-center border rounded px-3 py-2 shadow-sm"
          @click="toggle_feature(main_feature.id)"
          role="button"
        >
          <p class="m-0 text-xxs">{{ main_feature.name }}</p>
          <i :class="is_feature_expanded(main_feature.id) ? 'bi bi-chevron-up text-xxs' : 'bi bi-chevron-down text-xxs'"></i>
        </div>

        <div v-show="is_feature_expanded(main_feature.id)" class="pt-3">
          <div class="row" v-if="main_feature.sub_features.length > 0">
            <!-- Left Card - Sub Features -->
            <div class="col-md-6 mb-3">
              <div class="card bg-light border rounded shadow-sm">
                <div class="card-body p-2 text-xxs">
                  <p class="fw-bold">Select Sub-feature</p>
                  <div class="form-check mb-1"
                        v-for="sub_feature in main_feature.sub_features"
                        :key="sub_feature.id">
                    <input class="form-check-input form-check-input-sm shadow-sm"
                            type="checkbox"
                            :id="'sub-feature-' + sub_feature.id"
                            :checked="is_sub_feature_selected(main_feature.id, sub_feature.id)"
                            @change="handle_sub_feature_selection(main_feature.id, sub_feature.id)"
                    />
                    <label class="form-check-label text-xxs" :for="'sub-feature-' + sub_feature.id">
                      {{ sub_feature.name }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Right Card - CRUD Operations -->
            <div class="col-md-6 mb-3">
              <div class="card bg-light border rounded shadow-sm">
                <div class="card-body p-2 text-xxs">
                  <p class="fw-bold">Select Permission</p>
                  <div
                    class="form-check form-switch d-flex"
                    v-for="crud in (selected_sub_feature_map[main_feature.id]?.sub_feature_cruds || [])"
                    :key="crud.id"
                  >
                    <input
                      class="form-check-input me-2 shadow-sm"
                      type="checkbox"
                      :id="'crud-' + crud.id"
                      :checked="is_crud_selected(crud.id)"
                      @change="handle_crud_selection(crud.id, $event.target.checked)"
                    />
                    <label class="form-check-label text-xxs" :for="'crud-' + crud.id">
                      {{ crud.name }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="text-center text-xxs">
            <p class="border bg-light p-3 shadow-sm rounded">No sub-features available</p>
          </div>
        </div>
      </div>

      <!-- Assign Button -->
      <div class="text-end mt-4">
        <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="assign_permissions">
          Assign
        </button>
      </div>

    </div>
  </div>
</div>